import { cn } from '@lair-finance/util'
import { TokenAddresses, TokenImages, TokenTicker, TokenTickers } from '@/shared/config/token.ts'
import { TokenSymbol } from '@/shared/ui/Symbol'
import { AssetIcon } from '@/shared/ui/Asset'
import { WalletExtension } from '@/domains/wallet/lib/extentions/extension.ts'
import { wagmiGetAccount } from '@/shared/lib/wagmi/api/wagmiGetAccount.ts'
import { useChainId } from '@lair-finance/wagmi'
import { isNativeToken } from '@/shared/lib/utils/token.ts'

export const AssetItem = ({ className, ticker, amount }: { className?: string; ticker: TokenTicker; amount: string }) => {
  const chainId = useChainId()
  const tokenAddress = TokenAddresses[chainId][ticker]

  async function addAsset() {
    const account = await wagmiGetAccount()
    if (!account.connector) return

    await WalletExtension.addAsset(account.connector, ticker, tokenAddress)
  }

  return (
    <div className={cn('flex items-center justify-between gap-x-2 p-4 bg-greyscale-700 rounded-[12px]', className)}>
      <div className={'inline-flex items-center gap-x-2'}>
        <TokenSymbol src={TokenImages[ticker]} size={24} />
        <span className={'typo-new-label-2 text-greyscale-300'}>{TokenTickers[ticker]}</span>
        {isNativeToken(tokenAddress) ? (
          <AssetIcon className={'max-md:hidden'} filename={'new-wallet-darkgrey.png'} size={16} />
        ) : (
          <button className={'max-md:hidden group inline-flex'} onClick={addAsset}>
            <AssetIcon
              filename={isNativeToken(tokenAddress) ? 'new-wallet-darkgrey.png' : 'new-wallet-grey.png'}
              size={16}
              className={'group-hover:hidden'}
            />
            <AssetIcon filename={'new-wallet.png'} size={16} className={'hidden group-hover:inline-block'} />
          </button>
        )}
      </div>
      <strong className={'typo-new-label-2 text-greyscale-100'}>{amount}</strong>
    </div>
  )
}
